import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ICountriesDto, ICreateLocationsDto, ILocationsDto, IPagedCountryResultRequestDto, IPagedLocationResultRequestDto, IUpdateLocationsDto } from 'src/app/models/backend';
import { PagedResultDto } from 'src/app/shared/components/paged-listing-component-base';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocationsService {
  id: any;

  constructor(private http: HttpClient) { }

  // readonly url = environment.apiUrl+'Locations/';
  readonly url = environment.apiUrl+'Locations/'
  Token = localStorage.getItem("Token")
  headers = new HttpHeaders()
    .set('Content-Type', 'application/json; charset=utf-8')
    .set('Authorization', `Bearer ${this.Token}`);
  // headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
  
  createLocation(CreateProductDto: ICreateLocationsDto) {
    return this.http.post<ICreateLocationsDto>(this.url + 'CreateLocation', 
    CreateProductDto, { headers: this.headers })
  }

  updateLocation(payload: IUpdateLocationsDto): Observable<ILocationsDto> {
    return this.http.post<ILocationsDto>(`${this.url}UpdateLocation`, payload,{ headers: this.headers }).pipe(
      map(response => response)
    )
  }

  getLocations(payload:IPagedLocationResultRequestDto)
  {
    return this.http.post<PagedResultDto<ILocationsDto>>(this.url+'GetLocations',payload, { headers: this.headers });
  }

  GetLocation(id: number): Observable<ILocationsDto> {
    return this.http.get<ILocationsDto>(`${this.url}GetLocation/${id}`, { headers: this.headers }).pipe(
      map(response => response)
    )
  }
  DeleteLocation(id: number){
    return this.http.post(`${this.url}DeleteLocation/${id}`,null,{ headers: this.headers }).pipe(
      map(response => response)
    )



  }
  getCountries(payload:IPagedCountryResultRequestDto)
  {
    return this.http.post<PagedResultDto<ICountriesDto>>(environment.apiUrl+'Countries/GetCountries',payload, { headers: this.headers });
  }
  getActiveLocations(){
    return this.http.post(this.url+'GetActiveLocations',null, { headers: this.headers });
  }
}
